import React, { FC, useContext } from 'react';
import { Box, Icon, IconSize, Text, Theme, useMediaQuery, belowBreakpoint } from '@bechtel/gds';
import { StatBlockStyled } from './styled';
import { StatBlockProps } from './types';
import { ThemeContext } from 'styled-components';
import { StatsSpinner } from '@bechtel/client-common';

export const StatBlock: FC<StatBlockProps> = ({
  value,
  label,
  subLabel,
  valueText,
  icon,
  loading,
  iconFillColor,
  ...rest
}) => {
  const { breakpoints } = useContext<Theme>(ThemeContext);
  const isWideScreen = useMediaQuery(belowBreakpoint(breakpoints.widescreen));
  return (
    <StatBlockStyled {...rest}>
      <Box justifyContent={{ sm: 'space-between' }}>
        <Box>
          <Text size={isWideScreen ? '700' : '800'} color="grey.1000" family="graphik" weight="600">
            {!loading ? value : <StatsSpinner></StatsSpinner>}
          </Text>
          {valueText && (
            <Box pb={{ sm: '200' }} pl={{ sm: '300' }} alignSelf={{ sm: 'flex-end' }}>
              <Text size={isWideScreen ? '200' : '300'} weight="600" color="grey.1000">
                {valueText}
              </Text>
            </Box>
          )}
        </Box>
        {icon && (
          <Box>
            <Icon
              icon={icon}
              size={isWideScreen ? IconSize.MEDIUM : IconSize.LARGE}
              fillColor={iconFillColor ? iconFillColor : 'blue.800'}
            />
          </Box>
        )}
      </Box>
      {label && (
        <Box mt={{ sm: '450' }}>
          <Text size={isWideScreen ? '200' : '300'} color="grey.1000" weight="600" style={{ whiteSpace: 'nowrap' }}>
            {label}
          </Text>
        </Box>
      )}
      {subLabel && (
        <Box mt={{ sm: '300' }}>
          <Text size={isWideScreen ? '200' : '300'} color="grey.600" style={{ whiteSpace: 'nowrap' }}>
            {subLabel}
          </Text>
        </Box>
      )}
    </StatBlockStyled>
  );
};
